<section *ngIf="persona">
  <h2>{{ persona.name }}</h2>
  <iframe frameborder="0" [src]="registrationLink" #iframe></iframe>
</section>
